export const ChangeServiceStatus = {
    PENDING_USER_ACTIVATION: "PENDING_USER_ACTIVATION",
    DEACTIVATED: "DEACTIVATED",
    MISSING_DATA: "MISSING_DATA",
    TC_WITHDRAWN: "TC_WITHDRAWN",
    INCORRECT_DATA: "INCORRECT_DATA",
    INCORRECT_DATA_RESPONSE_AVAILABLE: "INCORRECT_DATA_RESPONSE_AVAILABLE",
    DATA_CHECK: "DATA_CHECK",
    EOD: "EOD",
    EOD_RESPONSE_AVAILABLE: "EOD_RESPONSE_AVAILABLE",
    READY_TO_CHANGE: "READY_TO_CHANGE",
    READY_TO_CHANGE_NEW: "READY_TO_CHANGE_NEW",
    TC_DENIED: "TC_DENIED",
    TC_DENIED_FB: "TC_DENIED",
    TC_DENIED_ZG: "TC_DENIED",
    TC_DENIED_FD: "TC_DENIED",
    TC_DENIED_AV: "TC_DENIED",
    TC_DENIED_GIP: "TC_DENIED",
    TC_DENIED_GU: "TC_DENIED",
    TC_SUCCESSFUL_WAITING_FOR_PROVIDER: "TC_SUCCESSFUL_WAITING_FOR_PROVIDER",
    TC_WAITING_FOR_AUTOMATION: "TC_WAITING_FOR_AUTOMATION",
    NEW: "NEW",
    MANAGED_BY_SALES: "MANAGED_BY_SALES",
};